<section class="assign-subfranchise-dialog" aria-labelledby="assign-subfranchise-title">
    <header class="dialog-header">
        <h2 id="assign-subfranchise-title">Assign to subfranchise</h2>
        <button type="button" class="dialog-close" aria-label="Close dialog" (click)="activeModal.dismiss()">
            <span aria-hidden="true">&times;</span>
        </button>
    </header>

    <div class="subfranchise-list" role="region" aria-label="Subfranchises" tabindex="0">
        <table class="subfranchise-table">
            <thead>
                <tr>
                    <th scope="col" class="number-column">S.NO</th>
                    <th scope="col" class="name-column">NAME</th>
                    <th scope="col" class="email-column">EMAIL ID</th>
                    <th scope="col" class="action-column">ACTION</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let records of allStaffRecords; let rowIndex = index">
                    <td class="number-column">{{rowIndex + 1}}</td>
                    <td class="name-cell">{{records.personalDetails.firstName}}</td>
                    <td class="email-cell">{{records.personalDetails.email}}</td>
                    <td class="action-column">
                        <button type="button" class="assign-button" (click)="assign(records)">
                            <span class="assign-icon" aria-hidden="true">+</span>
                            Assign
                        </button>
                    </td>
                </tr>
                <tr *ngIf="allStaffRecords.length === 0">
                    <td colspan="4" class="empty-state">No subfranchises available.</td>
                </tr>
            </tbody>
        </table>
    </div>
</section>